import { Vendor, VendorACH, VendorInternationalWire } from './coach-payment-report.js';

export const getCoachACHPaymentOrNull = (vendor?: Vendor): VendorACH | null => {
  switch (vendor?.payment_accounts?.details.type) {
    case 'ACH':
      return vendor as VendorACH;
    default:
      return null;
  }
};

export const getCoachPaymentInternationalOrNull = (vendor?: Vendor): VendorInternationalWire | null => {
  switch (vendor?.payment_accounts?.details.type) {
    case 'INTERNATIONAL_WIRE':
      return vendor as VendorInternationalWire;
    default:
      return null;
  }
};

export const maskAccountNumber = (accountNumber: string): string => {
  const last4 = accountNumber.slice(-4);
  return `*****${last4}`;
};
